import { render, staticRenderFns } from "./step_3.vue?vue&type=template&id=5f0e4acd&"
import script from "./step_3.vue?vue&type=script&lang=js&"
export * from "./step_3.vue?vue&type=script&lang=js&"
import style0 from "./step_3.vue?vue&type=style&index=0&id=5f0e4acd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports